import React from 'react';

import { gql } from '@apollo/client';
 
import { MusicNote } from '@mui/icons-material';

import { useQuery } from '@apollo/client'

import { Button, CircularProgress, Typography } from '@mui/material';

import { NodeTable } from '@/components/NodeTable';

import i18n from '@/i18n';
import moment from 'moment';

import { Link } from '@/components';

const QUERY = gql`
  query {
    spotify {
      artificialStreamsTrackReports {
        id
        start
        end
      }
    }
  }
`

export function ArtificialStreamingTracksReportsPage() {
  return ( 
    <ArtificialStreamingTracksReportsContainer /> 
  )
} 

export function ArtificialStreamingTracksReportsContainer() {

  const { data, loading } = useQuery(QUERY, {
    variables: {
    }
  })

  const onNodesChecked = () => {}
  const onPerformAction = () => {}

  if (loading) {
    return <CircularProgress />
  }

  if (data?.spotify?.artificialStreamsTrackReports) {
    const spotify = data?.spotify
    const artificialStreamsTrackReports = spotify?.artificialStreamsTrackReports
    return (
      <>
        <Typography level="h1">{i18n.t('Artificial streaming reports')}</Typography>
        <NodeTable
          onNodesChecked={onNodesChecked}
          onPerformAction={onPerformAction}
          canCheck={true}  
          renderRowClassNames={({ node }) => {    
            return !node.uncopyrighted || !node.notMatchesArtistWatchlist || !node.originalReleaseDateMatchesCopyrightYears || !node.originalReleaseDateIsNotDifferentFromCopyrightAndPhonographicYear ? 'row-warning' : ''
          }}
          emptyHeading={i18n.t('No reports found')}
          emptyText={i18n.t('No reports found')}
          emptyIcon={MusicNote}
    
          isRowUnavailable={(row) => {
            return false        
          }}
          toolbarButtons={() => <></>}
          sx={{
            '& .row-success': {
              bgcolor: 'rgba(0, 255, 0, .1)'
            },
            '& .row-error': {
              bgcolor: 'rgba(255, 0, 0, .1)'
            },
            '& .row-warning': {
              bgcolor: 'rgba(255, 255, 0, .1)'
            }
          }}
          actions={[ 
          ]}
          columns={[
            {
              id: 'name',
              name: i18n.t('name'),
              type: 'name',
              render: ({ node }) => {
                return (
                  <Link to={`/dashboard/screening/artificial-streaming/report/${node.id}`}>{node.start} - {node.end}</Link>
                )
              }
            }, 
            {
              id: 'view',
              name: i18n.t('created'),
              type: 'text',
              render: ({ node }) => { 
                return (
                  <Button 
                    onClick={(event) => {
                      event.preventDefault()
                      window.location.href = `/dashboard/screening/artificial-streaming/report/${node.id}`
                      return false
                    }}
                  >{
                    moment(node.created).format('YY-MM-DD')
                  }</Button>
                )
              }
            }
          ]}
          nodes={artificialStreamsTrackReports}
        />
      </>
    )
  } else {
    return (
      <p>Error</p>
    )
  }
}

export default ArtificialStreamingTracksReportsPage;
